/** Start the transport first, then notify UI owners without waiting for its response. */
export const beginEmailSend = <T>(send: () => Promise<T>, onStarted?: () => void): Promise<T> => {
    const request = send()
    onStarted?.()
    return request
}
